<style lang="scss">
    @import "@/assets/scss/vuexy/pages/Config.scss";
</style>
<template>
    <div class="item-grid-view vx-row match-height mt-4 edit-information-view">
        <div class="vx-col w-full">
          <vs-button :to="`/co/detail/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
        </div>
        <div class="vx-col w-full">
            <vx-card class="grid-view-item mb-base overflow-hidden">
                <h4>
                    {{$t("Labels.DeviceInformation")}}
                </h4>
                <form class="edit-form">
                    <div class="item-grid-view vx-row match-height mt-4">
                        <div class="lg:w-1/2 sm:w-1/2 w-full px-4">
                            <vs-input class="edit-info-input mb-4" :label="$t('Labels.DeviceName')" type="text" v-model="response.alias"/>
                            <vs-input class="edit-info-input mb-4" :label="$t('Labels.References')" type="text" v-model="response.label_location"/>
                            <vs-input class="edit-info-input mb-4" :label="$t('Labels.Notes')" type="text" v-model="response.notes"/>
                            <vs-input class="edit-info-input mb-4" :label="$t('Labels.DeviceRelay') + ' 1'" type="text" v-model="response.relay1_device"/>
                            <vs-input class="edit-info-input mb-4" :label="$t('Labels.DeviceRelay') + ' 2'" type="text" v-model="response.relay2_device"/>
                            <label class="vs-input--label">{{$t('Labels.SensorRelay') + ' 1'}}</label>
                            <v-select class="edit-info-input mb-4" :options="sensorOptions" v-model="response.relay1_sensor_assign"  :reduce="sensor => sensor.value" />
                            <label class="vs-input--label">{{$t('Labels.SensorRelay') + ' 2'}}</label>
                            <v-select class="edit-info-input mb-4" :options="sensorOptions" v-model="response.relay2_sensor_assign"  :reduce="sensor => sensor.value" />
                            <div class="text-center text-3xl mt-3" >{{$t("Labels.ReportTime")}}</div>
                            <vs-divider/>
                            <timeConfig v-if="response.time !== undefined" v-on:time="onTimeChange" v-on:unity="onUnityChange" :time="response.time !== ''? parseInt(response.time): 0" :unity="response.time_unity"/>
                            <div class="submit-button-container">
                              <vs-button @click="formSubmit" class="submit-button">
                                  {{$t("Labels.Save")}}
                              </vs-button>
                            </div>
                        </div>
                        <div class="vx-col lg:w-1/2 sm:w-1/2 w-full px-4">
                            <div class="map-container">
                                <l-map :center="center" :zoom="zoom" v-if="status_mapa">
                                    <l-tile-layer :attribution="attribution" :url="url">
                                    </l-tile-layer>
                                    <l-marker :draggable="draggable" :lat-lng="marker" ref="position_marker">
                                       <l-icon :icon-anchor="[12, 27]" >
                                          <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;" alt="ícono marcador"/>
                                      </l-icon>
                                    </l-marker>
                                </l-map>
                            </div>
                        </div>
                    </div>
                </form>
            </vx-card>
        </div>
    </div>
</template>
<script>
import { LMap, LTileLayer, LMarker, LIcon } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import timeConfig from '@/components/timeConfig/timeConfig.vue'
import { request } from '@/request.js'
import { empty } from '@/helpers.js'
import vSelect from 'vue-select'
/* global L:true */

const DATA = {
  code: 200,
  data: {
    uuid: 'cdfbacef-3540-41b5-aae3-448bcd330df4',
    deveui: '0011223344556677',
    serial: '1111111',
    alias: 'sensor 1 co2',
    label_location: 'en la biblioteca planta baja',
    notes: 'alguna nota extra no obligatiora',
    ppm_current: '800',
    ppm_max: '1000',
    ppm_min: '500',
    temp_current: '28.01',
    temp_max: '30.01',
    temp_min: '25.01',
    hum_current: '50',
    hum_max: '60',
    hum_min: '30',
    relay1_state: '0',
    relay2_state: '1',
    latlong: '20.6738686,-103.3704324',
    created_at: '2021-08-20 17:29:11',
    updated_at: '2021-08-23 11:08:06',
    time: 5,
    time_unity: 'hours'
  },
  msg: 'Ok'
}

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    timeConfig,
    vSelect
  },
  data () {
    return {
      zoom: 17,
      center: L.latLng(47.41322, -1.219482),
      url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
      attribution: '',
      marker: L.latLng(47.41322, -1.219482),
      draggable: true,
      response: [],
      time: 0,
      time_unity: '',
      uuid: this.$route.params.uuid,
      data: DATA,
      status_mapa: false,
      sensorOptions: [
        { label: this.$t('Labels.Temperature'), value: 'T' },
        { label: this.$t('Labels.Humidity'), value: 'H' },
        { label: this.$t('Labels.Co2'), value: 'C' }
      ]
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `co2_devices/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        if (!empty(this.response.latlong)) {
          const [lat, long] = this.response.latlong.split(',')
          this.marker = L.latLng(lat, long)
          this.center = L.latLng(lat, long)
          this.status_mapa = true
        }
      })
    },

    async formSubmit (e) {
      e.preventDefault()
      const location = this.$refs.position_marker.mapObject.getLatLng()
      this.response.location = `${location.lat},${location.lng}`
      const params = {
        url: `co2_devices/${this.uuid}/update`,
        method: 'PUT',
        params: {
          time: this.response.time,
          time_unity: this.response.time_unity,
          latlong: `${location.lat},${location.lng}`,
          alias: this.response.alias,
          label_location: this.response.location_string,
          notes: this.response.notes,
          relay1_sensor_assign: this.response.relay1_sensor_assign,
          relay2_sensor_assign: this.response.relay2_sensor_assign,
          relay1_device: this.response.relay1_device,
          relay2_device: this.response.relay2_device
        }
      }
      await request(params)
    },
    onTimeChange (value) {
      this.response.time = value
    },
    onUnityChange (value) {
      this.response.time_unity = value
    }
  },

  created () {
    this.getResponse()
  }
}
</script>
